package gr.tech.pdfgenerator.infrastructure.data

import androidx.compose.runtime.mutableStateOf
import gr.tech.pdfgenerator.models.DerivationsDTO
import gr.tech.pdfgenerator.models.GeneralInputsDTO
import gr.tech.pdfgenerator.models.MSAInputsDTO
import gr.tech.pdfgenerator.models.ProposalCalculationsDTO
import gr.tech.pdfgenerator.models.ProposalInputsDTO
import gr.tech.pdfgenerator.models.TierThreeDTO
import gr.tech.pdfgenerator.models.projects.ProjectDataDTO
import gr.tech.pdfgenerator.models.projects.ProjectsDTO
import gr.tech.pdfgenerator.infrastructure.calculations.recalculateDerivations
import gr.tech.pdfgenerator.infrastructure.calculations.recalculateProposalCalculations

object GeneratorData {
    var selectedTabName = mutableStateOf("")
    var selectedTabIndex = mutableStateOf(-1)

    // Remembering Values from the Project Selection Page
    var project = mutableStateOf(ProjectsDTO())

    // General Inputs Used By All *Saving to DB
    var generalInputsState = mutableStateOf(GeneralInputsDTO())

    // MSA Specific Inputs *Saving to DB
    var msaInputsState =  mutableStateOf(MSAInputsDTO())

    // Proposal Specific Inputs *Saving to DB
    var propInputState= mutableStateOf(
        ProposalInputsDTO(
            utilityRateInflation = 0.03,        //Default from Google Sheet
            hvacInteractionSavings = 0.33,     //Default from Google Sheet
            hvacUpTime = 0.66,                 //Default from Google Sheet
            hpsMaintenance = 6000              //Default from Google Sheet
        )
    )
    // Unique Derivations from Proposal *Derived from Inputs
    var derivationsState= mutableStateOf(DerivationsDTO())
    // Calculated Values from Proposal *Derived from Inputs
    var propCalculationsState = mutableStateOf(ProposalCalculationsDTO())

    // Tier Three Specific Inputs *Derived from Inputs
    var tierThreeState = mutableStateOf(TierThreeDTO())

    fun loadProjectFromDB(loadingProject: ProjectsDTO) {
        // Store the full project (metadata + data)
        project.value = loadingProject

        // If projectData exists, unpack and load the relevant sub-states
        loadingProject.projectData?.let { projectData ->
            generalInputsState.value = projectData.generalInputsState
            msaInputsState.value = projectData.msaInputsState
            propInputState.value = projectData.propInputState
            tierThreeState.value = projectData.tierThreeState

            derivationsState.value = recalculateDerivations(propInputState.value)

            propCalculationsState.value = recalculateProposalCalculations(
                inputState = propInputState.value,
                derivationsState = derivationsState.value
            )
        }
    }

    fun unloadProject() {
        // Reset full project reference
        project.value = ProjectsDTO()
        selectedTabName.value = ""
        selectedTabIndex.value = -1

        // Reset general saved inputs
        generalInputsState.value = GeneralInputsDTO()
        msaInputsState.value = MSAInputsDTO()
        propInputState.value = ProposalInputsDTO(
            utilityRateInflation = 0.03,        //Default from Google Sheet
            hvacInteractionSavings = 0.33,     //Default from Google Sheet
            hvacUpTime = 0.66,                 //Default from Google Sheet
            hpsMaintenance = 6000              //Default from Google Sheet
        )

        // Reset derived values and calculated values
        derivationsState.value = DerivationsDTO()
        propCalculationsState.value = ProposalCalculationsDTO()

        // Reset Tier 3 derived values
        tierThreeState.value = TierThreeDTO()
    }

    // This made it easier for me at the moment to call projectSaveToDatabase()
    // -by being able to pass just the project type to the function. Although, seeing it is
    // -not totally necessary, and maybe will clash with hasUnsavedChanges() in the future.
    fun saveProject() {
        project.value.projectData = ProjectDataDTO(
            generalInputsState = generalInputsState.value,
            msaInputsState = msaInputsState.value,
            propInputState = propInputState.value,
            tierThreeState = tierThreeState.value,
        )
    }

    fun hasUnsavedChanges(): Boolean {
        //TODO finished function
        return if (project.value.projectData != null) {
            generalInputsState.value != project.value.projectData!!.generalInputsState ||
                    msaInputsState.value != project.value.projectData!!.msaInputsState ||
                    propInputState.value != project.value.projectData!!.propInputState ||
                    tierThreeState.value != project.value.projectData!!.tierThreeState
        } else {
            true
        }
    }
}